// Transaction API Service
import { authApiService } from './authApiService';
import { API_URL } from '../config';

// Helper function to create authenticated headers
const getAuthHeaders = (additionalHeaders = {}) => {
  const token = authApiService.getStoredToken();
  return {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` }),
    ...additionalHeaders
  };
};

export const transactionApiService = {
  // Add a transaction (add/subtract minutes or sessions)
  async addTransaction({ clientId, type, amount, sessions, description, staff }) {
    const res = await fetch(`${API_URL}/transactions`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify({ clientId, type, amount, sessions, description, staff })
    });
    if (!res.ok) throw new Error('Failed to add transaction');
    return res.json();
  },

  // Get all transactions for a client
  async getTransactions(clientId) {
    const res = await fetch(`${API_URL}/transactions/${clientId}`, {
      headers: getAuthHeaders()
    });
    if (!res.ok) throw new Error('Failed to fetch transactions');
    return res.json();
  }
};
